import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SEOHead from './components/SEOHead';
import Home from './pages';
import GetQuote from './components/GetQuote';
import ContactUs from './components/ContactUs';
import SEOPage from './components/SEOPage';
import SocialPage from './components/SocialPage';
import DigitalPage from './components/DigitalPage';
import HaleyPage from './components/HaleyPage';
import MeetTheTeam from './components/MeetTheTeam';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import Careers from './components/Careers';
import Investors from './components/Investors';
import ScrollToTop from './components/ScrollToTop';

const TRACKING_ID = 'G-DS46QKSH5S';

function App() {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    ReactGA.send({ hitType: 'pageview', page: '/landingpage', title: 'Landing Page' });
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <SEOHead />
        <ScrollToTop />
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/getquote" element={<GetQuote />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/service/seo" element={<SEOPage />} />
        <Route path="/service/social-media" element={<SocialPage />} />
        <Route path="/service/digital" element={<DigitalPage />} />
        <Route path="/heli" element={<HaleyPage />} />
        <Route path="/meet-the-team" element={<MeetTheTeam />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/investors" element={<Investors />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
